import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-plan" }
const _hoisted_2 = { class: "group-name" }
const _hoisted_3 = { class: "flex flex-row gap-4" }
const _hoisted_4 = { class: "flex flex-row gap-4" }

import { computed, ref, watch } from "vue";
import { useI18n } from "vue-i18n";

import { maskCurrency } from "@/common/utils/mask";

import type {
	PlanPriceType,
	PlanPricePayloadType,
} from "@/common/types/plan/price";

import { baseInput, baseSelect, baseTextarea } from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'form-plan-price',
  props: {
    data: {},
    isPatch: { type: Boolean },
    isEdit: { type: Boolean }
  },
  emits: ["update:data", "validate"],
  setup(__props: any, { emit: __emit }) {

const { t, tm } = useI18n();

const emit = __emit;

const props = __props;

const DEFAULT_DATA = {
	stripe_price_id: "",
	type: "PLAN",
	name: "",
	currency: "BRL",
	frequency: "MONTHLY",
	status: "ACTIVE",
	price: 0,
	description: null,
};

const payload = ref<PlanPricePayloadType>({ ...DEFAULT_DATA });
const errors = ref<{ [key: string]: string }>({});

const mounted = ref(0);

const statusOptions = computed(() => [
	{ option: t("common.labels.active"), value: "ACTIVE" },
	{ option: t("common.labels.inactive"), value: "INACTIVE" },
]);

const typeOptions = computed(() => [
	{ option: "Plano", value: "PLAN" },
	{ option: "Affiliado", value: "AFFILIATE" },
]);

const frequencyOptions = computed(() => [
	{ option: "Mensal", value: "MONTHLY" },
	{ option: "Semestral", value: "SEMESTER" },
	{ option: "Anual", value: "YEARLY" },
]);

const currencyOptions = computed(() =>
	Object.entries(tm("enums.currencies") as Record<string, string>).map(
		([value, option]) => ({
			option,
			value,
		}),
	),
);

function validate() {
	const free = ["description"];

	Object.keys(payload.value).forEach((key) => {
		delete errors.value[key];

		if (!payload.value[key] && !free.includes(key))
			errors.value[key] = t("error.required");
	});

	console.log("errors", errors.value);

	emit("validate", Object.keys(errors.value).length === 0);
}

function update(key: keyof typeof payload.value) {
	validate();

	if (props.isPatch) {
		if (payload.value[key] === props.data[key]) return;

		emit("update:data", { [key]: payload.value[key] });
		return;
	}

	emit("update:data", payload.value);
}

function resumeData() {
	if (!props.data) return;

	const {
		stripe_price_id,
		currency,
		name,
		type,
		status,
		price: priceDecimal,
		frequency,
		description,
	} = props.data;

	const priceFloat = Number.parseFloat(priceDecimal?.toString()).toFixed(2);
	const priceString = maskCurrency(priceFloat, currency as any);

	payload.value = {
		stripe_price_id,
		currency,
		name,
		type,
		status,
		price: priceString as any,
		frequency,
		description,
	};

	mounted.value += 1;
}

function maskMoney(data: number) {
	return maskCurrency(data, payload.value.currency as any);
}

function changeCurrency() {
	payload.value.price = maskMoney(payload.value.price) as any;

	emit("update:data", {
		price: payload.value.price,
		currency: payload.value.currency,
	});
}

watch(
	() => mounted.value,
	() => {
		if (mounted.value === 1) {
			emit("update:data", payload.value);
		}
	},
);

watch(
	() => props.data,
	() => {
		resumeData();
	},
	{ immediate: true },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_unref(baseInput), {
        modelValue: payload.value.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((payload.value.name) = $event)),
        value: payload.value.name,
        placeholder: _unref(t)('common.placeholders.name'),
        required: "",
        maxlength: "75",
        onBlur: _cache[1] || (_cache[1] = ($event: any) => (update('name')))
      }, _createSlots({
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.name")) + " *", 1)
        ]),
        _: 2
      }, [
        (errors.value.name)
          ? {
              name: "error",
              fn: _withCtx(() => [
                _createTextVNode(_toDisplayString(errors.value.name), 1)
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["modelValue", "value", "placeholder"]),
      _createVNode(_unref(baseSelect), {
        modelValue: payload.value.status,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((payload.value.status) = $event)),
        value: payload.value.status,
        options: statusOptions.value,
        "is-empty": false,
        onChange: _cache[3] || (_cache[3] = ($event: any) => (update('status')))
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.status")), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value", "options"])
    ]),
    _createVNode(_unref(baseInput), {
      modelValue: payload.value.stripe_price_id,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((payload.value.stripe_price_id) = $event)),
      value: payload.value.stripe_price_id,
      onBlur: _cache[5] || (_cache[5] = ($event: any) => (update('stripe_price_id')))
    }, _createSlots({
      label: _withCtx(() => [
        _cache[16] || (_cache[16] = _createTextVNode(" Stripe Preço ID *", -1))
      ]),
      _: 2
    }, [
      (errors.value.stripe_price_id)
        ? {
            name: "error",
            fn: _withCtx(() => [
              _createTextVNode(_toDisplayString(errors.value.stripe_price_id), 1)
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["modelValue", "value"]),
    _createElementVNode("section", _hoisted_3, [
      _createVNode(_unref(baseSelect), {
        modelValue: payload.value.type,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((payload.value.type) = $event)),
        value: payload.value.type,
        options: typeOptions.value,
        "is-empty": false,
        onChange: _cache[7] || (_cache[7] = ($event: any) => (update('type')))
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.type")), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value", "options"]),
      _createVNode(_unref(baseSelect), {
        modelValue: payload.value.frequency,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((payload.value.frequency) = $event)),
        value: payload.value.frequency,
        options: frequencyOptions.value,
        "is-empty": false,
        onChange: _cache[9] || (_cache[9] = ($event: any) => (update('frequency')))
      }, {
        label: _withCtx(() => [...(_cache[17] || (_cache[17] = [
          _createTextVNode(" Frequência *", -1)
        ]))]),
        _: 1
      }, 8, ["modelValue", "value", "options"])
    ]),
    _createElementVNode("section", _hoisted_4, [
      _createVNode(_unref(baseSelect), {
        modelValue: payload.value.currency,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((payload.value.currency) = $event)),
        value: payload.value.currency,
        options: currencyOptions.value,
        "is-empty": false,
        onChange: _cache[11] || (_cache[11] = ($event: any) => (changeCurrency()))
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.currency")), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value", "options"]),
      _createVNode(_unref(baseInput), {
        modelValue: payload.value.price,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((payload.value.price) = $event)),
        value: payload.value.price,
        mask: maskMoney,
        onBlur: _cache[13] || (_cache[13] = ($event: any) => (update('price')))
      }, _createSlots({
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.price")) + " *", 1)
        ]),
        _: 2
      }, [
        (errors.value.price)
          ? {
              name: "error",
              fn: _withCtx(() => [
                _createTextVNode(_toDisplayString(errors.value.price), 1)
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["modelValue", "value"])
    ]),
    _createVNode(_unref(baseTextarea), {
      modelValue: payload.value.description,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((payload.value.description) = $event)),
      value: payload.value.description,
      rows: 5,
      onBlur: _cache[15] || (_cache[15] = ($event: any) => (update('description')))
    }, {
      label: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)("common.labels.description")), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "value"])
  ]))
}
}

})